"use strict";
/* tslint:disable */
/* eslint-disable */
/*
Carbon

Connect external data to LLMs, no matter the source.

The version of the OpenAPI document: 1.0.0


NOTE: This file is auto generated by Konfig (https://konfigthis.com).
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationsApiGenerated = exports.IntegrationsApiFactory = exports.IntegrationsApiFp = exports.IntegrationsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
const FormData = require("form-data");
// @ts-ignore
const base_1 = require("../base");
const requestBeforeHook_1 = require("../requestBeforeHook");
/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
const IntegrationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Cancel Data Source Items Sync
         * @param {SyncDirectoryRequest} syncDirectoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: (syncDirectoryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'syncDirectoryRequest' is not null or undefined
            (0, common_1.assertParamExists)('cancel', 'syncDirectoryRequest', syncDirectoryRequest);
            const localVarPath = `/integrations/items/sync/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: syncDirectoryRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/items/sync/cancel',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(syncDirectoryRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Connect Data Source
         * @param {ConnectDataSourceInput} connectDataSourceInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectDataSource: (connectDataSourceInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'connectDataSourceInput' is not null or undefined
            (0, common_1.assertParamExists)('connectDataSource', 'connectDataSourceInput', connectDataSourceInput);
            const localVarPath = `/integrations/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: connectDataSourceInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/connect',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(connectDataSourceInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Refer this article to obtain an API key https://support.freshdesk.com/en/support/solutions/articles/215517. Make sure that your API key has the permission to read solutions from your account and you are on a <b>paid</b> plan. Once you have an API key, you can make a request to this endpoint along with your freshdesk domain. This will  trigger an automatic sync of the articles in your \"solutions\" tab. Additional parameters below can be used to associate  data with the synced articles or modify the sync behavior.
         * @summary Freshdesk Connect
         * @param {FreshDeskConnectRequest} freshDeskConnectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectFreshdesk: (freshDeskConnectRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'freshDeskConnectRequest' is not null or undefined
            (0, common_1.assertParamExists)('connectFreshdesk', 'freshDeskConnectRequest', freshDeskConnectRequest);
            const localVarPath = `/integrations/freshdesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: freshDeskConnectRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/freshdesk',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freshDeskConnectRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * You will need an access token to connect your Gitbook account. Note that the permissions will be defined by the user  generating access token so make sure you have the permission to access spaces you will be syncing.  Refer this article for more details https://developer.gitbook.com/gitbook-api/authentication. Additionally, you need to specify the name of organization you will be syncing data from.
         * @summary Gitbook Connect
         * @param {GitbookConnectRequest} gitbookConnectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGitbook: (gitbookConnectRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gitbookConnectRequest' is not null or undefined
            (0, common_1.assertParamExists)('connectGitbook', 'gitbookConnectRequest', gitbookConnectRequest);
            const localVarPath = `/integrations/gitbook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: gitbookConnectRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/gitbook',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gitbookConnectRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * You will need an access token to connect your Guru account. To obtain an access token, follow the steps highlighted here https://help.getguru.com/docs/gurus-api#obtaining-a-user-token. The username should be your Guru username.
         * @summary Guru Connect
         * @param {GuruConnectRequest} guruConnectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGuru: (guruConnectRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'guruConnectRequest' is not null or undefined
            (0, common_1.assertParamExists)('connectGuru', 'guruConnectRequest', guruConnectRequest);
            const localVarPath = `/integrations/guru`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: guruConnectRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/guru',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(guruConnectRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint can be used to connect S3 as well as Digital Ocean Spaces (S3 compatible)   For S3, create a new IAM user with permissions to: <ol> <li>List all buckets.</li> <li>Read from the specific buckets and objects to sync with Carbon. Ensure any future buckets or objects carry  the same permissions.</li> </ol> Once created, generate an access key for this user and share the credentials with us. We recommend testing this key beforehand.   For Digital Ocean Spaces, generate the above credentials in your Applications and API page here https://cloud.digitalocean.com/account/api/spaces. Endpoint URL is required to connect Digital Ocean Spaces. It should look like <<region>>.digitaloceanspaces.com
         * @summary S3 Auth
         * @param {S3AuthRequest} s3AuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAwsIamUser: (s3AuthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 's3AuthRequest' is not null or undefined
            (0, common_1.assertParamExists)('createAwsIamUser', 's3AuthRequest', s3AuthRequest);
            const localVarPath = `/integrations/s3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: s3AuthRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/s3',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(s3AuthRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint can be used to generate the following URLs - An OAuth URL for OAuth based connectors - A file syncing URL which skips the OAuth flow if the user already has a valid access token and takes them to the success state.
         * @summary Get Oauth Url
         * @param {OAuthURLRequest} oAuthURLRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthUrl: (oAuthURLRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'oAuthURLRequest' is not null or undefined
            (0, common_1.assertParamExists)('getOauthUrl', 'oAuthURLRequest', oAuthURLRequest);
            const localVarPath = `/integrations/oauth_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: oAuthURLRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/oauth_url',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(oAuthURLRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint has been deprecated. Use /integrations/items/list instead.  To begin listing a user\'s Confluence pages, at least a `data_source_id` of a connected Confluence account must be specified. This base request returns a list of root pages for every space the user has access to in a Confluence instance. To traverse further down the user\'s page directory, additional requests to this endpoint can be made with the same `data_source_id` and with `parent_id` set to the id of page from a previous request. For convenience, the `has_children` property in each directory item in the response list will flag which pages will return non-empty lists of pages when set as the `parent_id`.
         * @summary Confluence List
         * @param {ListRequest} listRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listConfluencePages: (listRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'listRequest' is not null or undefined
            (0, common_1.assertParamExists)('listConfluencePages', 'listRequest', listRequest);
            const localVarPath = `/integrations/confluence/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: listRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/confluence/list',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(listRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List all of your public and private channels, DMs, and Group DMs. The ID from response  can be used as a filter to sync messages to Carbon    types: Comma separated list of types. Available types are im (DMs), mpim (group DMs), public_channel, and private_channel. Defaults to public_channel.     cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request     data_source_id: Data source needs to be specified if you have linked multiple slack accounts   exclude_archived: Should archived conversations be excluded, defaults to true
         * @summary Slack List Conversations
         * @param {string} [types]
         * @param {string} [cursor]
         * @param {number} [dataSourceId]
         * @param {boolean} [excludeArchived]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversations: (types, cursor, dataSourceId, excludeArchived, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integrations/slack/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            if (excludeArchived !== undefined) {
                localVarQueryParameter['exclude_archived'] = excludeArchived;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/slack/conversations',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Data Source Items
         * @param {ListDataSourceItemsRequest} listDataSourceItemsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDataSourceItems: (listDataSourceItemsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'listDataSourceItemsRequest' is not null or undefined
            (0, common_1.assertParamExists)('listDataSourceItems', 'listDataSourceItemsRequest', listDataSourceItemsRequest);
            const localVarPath = `/integrations/items/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: listDataSourceItemsRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/items/list',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(listDataSourceItemsRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * After connecting your Outlook account, you can use this endpoint to list all of your folders on outlook. This includes  both system folders like \"inbox\" and user created folders.
         * @summary Outlook Folders
         * @param {number} [dataSourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolders: (dataSourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integrations/outlook/user_folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/outlook/user_folders',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * After connecting your Gitbook account, you can use this endpoint to list all of your spaces under current organization.
         * @summary Gitbook Spaces
         * @param {number} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGitbookSpaces: (dataSourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dataSourceId' is not null or undefined
            (0, common_1.assertParamExists)('listGitbookSpaces', 'dataSourceId', dataSourceId);
            const localVarPath = `/integrations/gitbook/spaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/gitbook/spaces',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * After connecting your Gmail account, you can use this endpoint to list all of your labels. User created labels will have the type \"user\" and Gmail\'s default labels will have the type \"system\"
         * @summary Gmail Labels
         * @param {number} [dataSourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels: (dataSourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integrations/gmail/user_labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/gmail/user_labels',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * After connecting your Outlook account, you can use this endpoint to list all of your categories on outlook. We currently support listing up to 250 categories.
         * @summary Outlook Categories
         * @param {number} [dataSourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOutlookCategories: (dataSourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integrations/outlook/user_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/outlook/user_categories',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Once you have connected your GitHub account, you can use this endpoint to list the      repositories your account has access to. You can use a data source ID or username to fetch from a specific account.
         * @summary Github List Repos
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [dataSourceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRepos: (perPage, page, dataSourceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integrations/github/repos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/github/repos',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List all Sharepoint sites in the connected tenant. The site names from the response can be used as the site name when connecting a Sharepoint site. If site name is null in the response, then site name should be left null when connecting to the site.  This endpoint requires an additional Sharepoint scope: \"Sites.Read.All\". Include this scope along with the default Sharepoint scopes to list Sharepoint sites, connect to a site, and finally sync files from the site. The default Sharepoint scopes are: [o, p, e, n, i, d,  , o, f, f, l, i, n, e, _, a, c, c, e, s, s,  , U, s, e, r, ., R, e, a, d,  , F, i, l, e, s, ., R, e, a, d, ., A, l, l].   data_soure_id: Data source needs to be specified if you have linked multiple Sharepoint accounts cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request
         * @summary List Sharepoint Sites
         * @param {number} [dataSourceId]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharepointSites: (dataSourceId, cursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integrations/sharepoint/sites/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/sharepoint/sites/list',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the container name  and file name as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
         * @summary Azure Blob Files
         * @param {AzureBlobFileSyncInput} azureBlobFileSyncInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAzureBlobFiles: (azureBlobFileSyncInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'azureBlobFileSyncInput' is not null or undefined
            (0, common_1.assertParamExists)('syncAzureBlobFiles', 'azureBlobFileSyncInput', azureBlobFileSyncInput);
            const localVarPath = `/integrations/azure_blob_storage/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: azureBlobFileSyncInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/azure_blob_storage/files',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(azureBlobFileSyncInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint can be used to connect Azure Blob Storage.  For Azure Blob Storage, follow these steps: <ol>   <li>Create a new Azure Storage account and grant the following permissions:     <ul>       <li>List containers.</li>       <li>Read from specific containers and blobs to sync with Carbon. Ensure any future containers or blobs carry the same permissions.</li>     </ul>   </li>   <li>Generate a shared access signature (SAS) token or an access key for the storage account.</li> </ol>  Once created, provide us with the following details to generate the connection URL: <ol>   <li>Storage Account KeyName.</li>   <li>Storage Account Name.</li> </ol>
         * @summary Azure Blob Storage Auth
         * @param {AzureBlobAuthRequest} azureBlobAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAzureBlobStorage: (azureBlobAuthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'azureBlobAuthRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncAzureBlobStorage', 'azureBlobAuthRequest', azureBlobAuthRequest);
            const localVarPath = `/integrations/azure_blob_storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: azureBlobAuthRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/azure_blob_storage',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(azureBlobAuthRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint has been deprecated. Use /integrations/files/sync instead.  After listing pages in a user\'s Confluence account, the set of selected page `ids` and the connected account\'s `data_source_id` can be passed into this endpoint to sync them into Carbon. Additional parameters listed below can be used to associate data to the selected pages or alter the behavior of the sync.
         * @summary Confluence Sync
         * @param {SyncFilesRequest} syncFilesRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        syncConfluence: (syncFilesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'syncFilesRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncConfluence', 'syncFilesRequest', syncFilesRequest);
            const localVarPath = `/integrations/confluence/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: syncFilesRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/confluence/sync',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(syncFilesRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync Data Source Items
         * @param {SyncDirectoryRequest} syncDirectoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDataSourceItems: (syncDirectoryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'syncDirectoryRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncDataSourceItems', 'syncDirectoryRequest', syncDirectoryRequest);
            const localVarPath = `/integrations/items/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: syncDirectoryRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/items/sync',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(syncDirectoryRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * After listing files and folders via /integrations/items/sync and integrations/items/list, use the selected items\' external ids  as the ids in this endpoint to sync them into Carbon. Sharepoint items take an additional parameter root_id, which identifies the drive the file or folder is in and is stored in root_external_id. That additional paramter is optional and excluding it will tell the sync to assume the item is stored in the default Documents drive.
         * @summary Sync Files
         * @param {SyncFilesRequest} syncFilesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFiles: (syncFilesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'syncFilesRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncFiles', 'syncFilesRequest', syncFilesRequest);
            const localVarPath = `/integrations/files/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: syncFilesRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/files/sync',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(syncFilesRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Refer this article to obtain an access token https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/managing-your-personal-access-tokens. Make sure that your access token has the permission to read content from your desired repos. Note that if your access token expires you will need to manually update it through this endpoint.
         * @summary Github Connect
         * @param {GithubConnectRequest} githubConnectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitHub: (githubConnectRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'githubConnectRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncGitHub', 'githubConnectRequest', githubConnectRequest);
            const localVarPath = `/integrations/github`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: githubConnectRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/github',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(githubConnectRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * You can sync upto 20 Gitbook spaces at a time using this endpoint. Additional parameters below can be used to associate  data with the synced pages or modify the sync behavior.
         * @summary Gitbook Sync
         * @param {GitbookSyncRequest} gitbookSyncRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitbook: (gitbookSyncRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gitbookSyncRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncGitbook', 'gitbookSyncRequest', gitbookSyncRequest);
            const localVarPath = `/integrations/gitbook/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: gitbookSyncRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/gitbook/sync',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gitbookSyncRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Once you have successfully connected your gmail account, you can choose which emails to sync with us using the filters parameter. Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>label</b>: Inbuilt Gmail labels, for example \"Important\" or a custom label you created.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.   <b>is</b>: Can have the following values - starred, important, snoozed, and unread   <b>from</b>: Email address of the sender   <b>to</b>: Email address of the recipient   <b>in</b>: Can have the following values - sent (sync emails sent by the user)   <b>has</b>: Can have the following values - attachment (sync emails that have attachments)    Using keys or values outside of the specified values can lead to unexpected behaviour.  An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"label\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the label \"Test\".  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"label\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"is\",                         \"value\": \"starred\"                     }                 ]             }         ]     } } ``` This will return emails after 7th of Jan that are either starred or have the label \"Personal\".  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
         * @summary Gmail Sync
         * @param {GmailSyncInput} gmailSyncInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGmail: (gmailSyncInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gmailSyncInput' is not null or undefined
            (0, common_1.assertParamExists)('syncGmail', 'gmailSyncInput', gmailSyncInput);
            const localVarPath = `/integrations/gmail/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: gmailSyncInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/gmail/sync',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gmailSyncInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Once you have successfully connected your Outlook account, you can choose which emails to sync with us using the filters and folder parameter. \"folder\" should be the folder you want to sync from Outlook. By default we get messages from your inbox folder.   Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>category</b>: Custom categories that you created in Outlook.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.     <b>is</b>: Can have the following values: flagged   <b>from</b>: Email address of the sender     An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the category \"Test\".    Specifying a custom folder in the same query ```json {     \"folder\": \"Folder Name\",     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ```  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"category\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"category\",                         \"value\": \"Test\"                     },                 ]             }         ]     } } ``` This will return emails after 7th of Jan that have either Personal or Test as category.  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
         * @summary Outlook Sync
         * @param {OutlookSyncInput} outlookSyncInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOutlook: (outlookSyncInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'outlookSyncInput' is not null or undefined
            (0, common_1.assertParamExists)('syncOutlook', 'outlookSyncInput', outlookSyncInput);
            const localVarPath = `/integrations/outlook/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: outlookSyncInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/outlook/sync',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(outlookSyncInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * You can retreive repos your token has access to using /integrations/github/repos and sync their content.  You can also pass full name of any public repository (username/repo-name). This will store the repo content with  carbon which can be accessed through /integrations/items/list endpoint. Maximum of 25 repositories are accepted per request.
         * @summary Github Sync Repos
         * @param {GithubFetchReposRequest} githubFetchReposRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRepos: (githubFetchReposRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'githubFetchReposRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncRepos', 'githubFetchReposRequest', githubFetchReposRequest);
            const localVarPath = `/integrations/github/sync_repos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: githubFetchReposRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/github/sync_repos',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(githubFetchReposRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Rss Feed
         * @param {RSSFeedInput} rSSFeedInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRssFeed: (rSSFeedInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rSSFeedInput' is not null or undefined
            (0, common_1.assertParamExists)('syncRssFeed', 'rSSFeedInput', rSSFeedInput);
            const localVarPath = `/integrations/rss_feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: rSSFeedInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/rss_feed',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rSSFeedInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the bucket name  and object key as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
         * @summary S3 Files
         * @param {S3FileSyncInput} s3FileSyncInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncS3Files: (s3FileSyncInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 's3FileSyncInput' is not null or undefined
            (0, common_1.assertParamExists)('syncS3Files', 's3FileSyncInput', s3FileSyncInput);
            const localVarPath = `/integrations/s3/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: s3FileSyncInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/s3/files',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(s3FileSyncInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * You can list all conversations using the endpoint /integrations/slack/conversations. The ID of  conversation will be used as an input for this endpoint with timestamps as optional filters.
         * @summary Slack Sync
         * @param {SlackSyncRequest} slackSyncRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSlack: (slackSyncRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'slackSyncRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncSlack', 'slackSyncRequest', slackSyncRequest);
            const localVarPath = `/integrations/slack/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: slackSyncRequest,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/integrations/slack/sync',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(slackSyncRequest, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.IntegrationsApiAxiosParamCreator = IntegrationsApiAxiosParamCreator;
/**
 * IntegrationsApi - functional programming interface
 * @export
 */
const IntegrationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.IntegrationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Cancel Data Source Items Sync
         * @param {IntegrationsApiCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const syncDirectoryRequest = {
                    data_source_id: requestParameters.data_source_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancel(syncDirectoryRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Connect Data Source
         * @param {IntegrationsApiConnectDataSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectDataSource(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const connectDataSourceInput = {
                    authentication: requestParameters.authentication,
                    sync_options: requestParameters.sync_options
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.connectDataSource(connectDataSourceInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Refer this article to obtain an API key https://support.freshdesk.com/en/support/solutions/articles/215517. Make sure that your API key has the permission to read solutions from your account and you are on a <b>paid</b> plan. Once you have an API key, you can make a request to this endpoint along with your freshdesk domain. This will  trigger an automatic sync of the articles in your \"solutions\" tab. Additional parameters below can be used to associate  data with the synced articles or modify the sync behavior.
         * @summary Freshdesk Connect
         * @param {IntegrationsApiConnectFreshdeskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectFreshdesk(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const freshDeskConnectRequest = {
                    tags: requestParameters.tags,
                    domain: requestParameters.domain,
                    api_key: requestParameters.api_key,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    sync_files_on_connection: requestParameters.sync_files_on_connection,
                    request_id: requestParameters.request_id,
                    sync_source_items: requestParameters.sync_source_items,
                    file_sync_config: requestParameters.file_sync_config,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.connectFreshdesk(freshDeskConnectRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * You will need an access token to connect your Gitbook account. Note that the permissions will be defined by the user  generating access token so make sure you have the permission to access spaces you will be syncing.  Refer this article for more details https://developer.gitbook.com/gitbook-api/authentication. Additionally, you need to specify the name of organization you will be syncing data from.
         * @summary Gitbook Connect
         * @param {IntegrationsApiConnectGitbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGitbook(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const gitbookConnectRequest = {
                    tags: requestParameters.tags,
                    organization: requestParameters.organization,
                    access_token: requestParameters.access_token,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    sync_files_on_connection: requestParameters.sync_files_on_connection,
                    request_id: requestParameters.request_id,
                    sync_source_items: requestParameters.sync_source_items,
                    file_sync_config: requestParameters.file_sync_config,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.connectGitbook(gitbookConnectRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * You will need an access token to connect your Guru account. To obtain an access token, follow the steps highlighted here https://help.getguru.com/docs/gurus-api#obtaining-a-user-token. The username should be your Guru username.
         * @summary Guru Connect
         * @param {IntegrationsApiConnectGuruRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGuru(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const guruConnectRequest = {
                    tags: requestParameters.tags,
                    username: requestParameters.username,
                    access_token: requestParameters.access_token,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    sync_files_on_connection: requestParameters.sync_files_on_connection,
                    request_id: requestParameters.request_id,
                    sync_source_items: requestParameters.sync_source_items,
                    file_sync_config: requestParameters.file_sync_config,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.connectGuru(guruConnectRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint can be used to connect S3 as well as Digital Ocean Spaces (S3 compatible)   For S3, create a new IAM user with permissions to: <ol> <li>List all buckets.</li> <li>Read from the specific buckets and objects to sync with Carbon. Ensure any future buckets or objects carry  the same permissions.</li> </ol> Once created, generate an access key for this user and share the credentials with us. We recommend testing this key beforehand.   For Digital Ocean Spaces, generate the above credentials in your Applications and API page here https://cloud.digitalocean.com/account/api/spaces. Endpoint URL is required to connect Digital Ocean Spaces. It should look like <<region>>.digitaloceanspaces.com
         * @summary S3 Auth
         * @param {IntegrationsApiCreateAwsIamUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAwsIamUser(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const s3AuthRequest = {
                    access_key: requestParameters.access_key,
                    access_key_secret: requestParameters.access_key_secret,
                    sync_source_items: requestParameters.sync_source_items,
                    endpoint_url: requestParameters.endpoint_url,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAwsIamUser(s3AuthRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint can be used to generate the following URLs - An OAuth URL for OAuth based connectors - A file syncing URL which skips the OAuth flow if the user already has a valid access token and takes them to the success state.
         * @summary Get Oauth Url
         * @param {IntegrationsApiGetOauthUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthUrl(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const oAuthURLRequest = {
                    tags: requestParameters.tags,
                    scope: requestParameters.scope,
                    scopes: requestParameters.scopes,
                    service: requestParameters.service,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    zendesk_subdomain: requestParameters.zendesk_subdomain,
                    microsoft_tenant: requestParameters.microsoft_tenant,
                    sharepoint_site_name: requestParameters.sharepoint_site_name,
                    confluence_subdomain: requestParameters.confluence_subdomain,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    max_items_per_chunk: requestParameters.max_items_per_chunk,
                    salesforce_domain: requestParameters.salesforce_domain,
                    sync_files_on_connection: requestParameters.sync_files_on_connection,
                    set_page_as_boundary: requestParameters.set_page_as_boundary,
                    data_source_id: requestParameters.data_source_id,
                    connecting_new_account: requestParameters.connecting_new_account,
                    request_id: requestParameters.request_id,
                    use_ocr: requestParameters.use_ocr,
                    parse_pdf_tables_with_ocr: requestParameters.parse_pdf_tables_with_ocr,
                    enable_file_picker: requestParameters.enable_file_picker,
                    sync_source_items: requestParameters.sync_source_items,
                    incremental_sync: requestParameters.incremental_sync,
                    file_sync_config: requestParameters.file_sync_config,
                    automatically_open_file_picker: requestParameters.automatically_open_file_picker,
                    gong_account_email: requestParameters.gong_account_email,
                    servicenow_credentials: requestParameters.servicenow_credentials,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOauthUrl(oAuthURLRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint has been deprecated. Use /integrations/items/list instead.  To begin listing a user\'s Confluence pages, at least a `data_source_id` of a connected Confluence account must be specified. This base request returns a list of root pages for every space the user has access to in a Confluence instance. To traverse further down the user\'s page directory, additional requests to this endpoint can be made with the same `data_source_id` and with `parent_id` set to the id of page from a previous request. For convenience, the `has_children` property in each directory item in the response list will flag which pages will return non-empty lists of pages when set as the `parent_id`.
         * @summary Confluence List
         * @param {IntegrationsApiListConfluencePagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listConfluencePages(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const listRequest = {
                    data_source_id: requestParameters.data_source_id,
                    parent_id: requestParameters.parent_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listConfluencePages(listRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List all of your public and private channels, DMs, and Group DMs. The ID from response  can be used as a filter to sync messages to Carbon    types: Comma separated list of types. Available types are im (DMs), mpim (group DMs), public_channel, and private_channel. Defaults to public_channel.     cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request     data_source_id: Data source needs to be specified if you have linked multiple slack accounts   exclude_archived: Should archived conversations be excluded, defaults to true
         * @summary Slack List Conversations
         * @param {IntegrationsApiListConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversations(requestParameters = {}, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listConversations(requestParameters.types, requestParameters.cursor, requestParameters.dataSourceId, requestParameters.excludeArchived, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List Data Source Items
         * @param {IntegrationsApiListDataSourceItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDataSourceItems(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const listDataSourceItemsRequest = {
                    data_source_id: requestParameters.data_source_id,
                    parent_id: requestParameters.parent_id,
                    filters: requestParameters.filters,
                    pagination: requestParameters.pagination,
                    order_by: requestParameters.order_by,
                    order_dir: requestParameters.order_dir
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listDataSourceItems(listDataSourceItemsRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * After connecting your Outlook account, you can use this endpoint to list all of your folders on outlook. This includes  both system folders like \"inbox\" and user created folders.
         * @summary Outlook Folders
         * @param {IntegrationsApiListFoldersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolders(requestParameters = {}, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listFolders(requestParameters.dataSourceId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * After connecting your Gitbook account, you can use this endpoint to list all of your spaces under current organization.
         * @summary Gitbook Spaces
         * @param {IntegrationsApiListGitbookSpacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGitbookSpaces(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listGitbookSpaces(requestParameters.dataSourceId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * After connecting your Gmail account, you can use this endpoint to list all of your labels. User created labels will have the type \"user\" and Gmail\'s default labels will have the type \"system\"
         * @summary Gmail Labels
         * @param {IntegrationsApiListLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels(requestParameters = {}, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLabels(requestParameters.dataSourceId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * After connecting your Outlook account, you can use this endpoint to list all of your categories on outlook. We currently support listing up to 250 categories.
         * @summary Outlook Categories
         * @param {IntegrationsApiListOutlookCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOutlookCategories(requestParameters = {}, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOutlookCategories(requestParameters.dataSourceId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Once you have connected your GitHub account, you can use this endpoint to list the      repositories your account has access to. You can use a data source ID or username to fetch from a specific account.
         * @summary Github List Repos
         * @param {IntegrationsApiListReposRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRepos(requestParameters = {}, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRepos(requestParameters.perPage, requestParameters.page, requestParameters.dataSourceId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List all Sharepoint sites in the connected tenant. The site names from the response can be used as the site name when connecting a Sharepoint site. If site name is null in the response, then site name should be left null when connecting to the site.  This endpoint requires an additional Sharepoint scope: \"Sites.Read.All\". Include this scope along with the default Sharepoint scopes to list Sharepoint sites, connect to a site, and finally sync files from the site. The default Sharepoint scopes are: [o, p, e, n, i, d,  , o, f, f, l, i, n, e, _, a, c, c, e, s, s,  , U, s, e, r, ., R, e, a, d,  , F, i, l, e, s, ., R, e, a, d, ., A, l, l].   data_soure_id: Data source needs to be specified if you have linked multiple Sharepoint accounts cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request
         * @summary List Sharepoint Sites
         * @param {IntegrationsApiListSharepointSitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharepointSites(requestParameters = {}, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSharepointSites(requestParameters.dataSourceId, requestParameters.cursor, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the container name  and file name as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
         * @summary Azure Blob Files
         * @param {IntegrationsApiSyncAzureBlobFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAzureBlobFiles(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const azureBlobFileSyncInput = {
                    tags: requestParameters.tags,
                    ids: requestParameters.ids,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    max_items_per_chunk: requestParameters.max_items_per_chunk,
                    set_page_as_boundary: requestParameters.set_page_as_boundary,
                    data_source_id: requestParameters.data_source_id,
                    request_id: requestParameters.request_id,
                    use_ocr: requestParameters.use_ocr,
                    parse_pdf_tables_with_ocr: requestParameters.parse_pdf_tables_with_ocr,
                    file_sync_config: requestParameters.file_sync_config
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncAzureBlobFiles(azureBlobFileSyncInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint can be used to connect Azure Blob Storage.  For Azure Blob Storage, follow these steps: <ol>   <li>Create a new Azure Storage account and grant the following permissions:     <ul>       <li>List containers.</li>       <li>Read from specific containers and blobs to sync with Carbon. Ensure any future containers or blobs carry the same permissions.</li>     </ul>   </li>   <li>Generate a shared access signature (SAS) token or an access key for the storage account.</li> </ol>  Once created, provide us with the following details to generate the connection URL: <ol>   <li>Storage Account KeyName.</li>   <li>Storage Account Name.</li> </ol>
         * @summary Azure Blob Storage Auth
         * @param {IntegrationsApiSyncAzureBlobStorageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAzureBlobStorage(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const azureBlobAuthRequest = {
                    account_name: requestParameters.account_name,
                    account_key: requestParameters.account_key,
                    sync_source_items: requestParameters.sync_source_items,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncAzureBlobStorage(azureBlobAuthRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint has been deprecated. Use /integrations/files/sync instead.  After listing pages in a user\'s Confluence account, the set of selected page `ids` and the connected account\'s `data_source_id` can be passed into this endpoint to sync them into Carbon. Additional parameters listed below can be used to associate data to the selected pages or alter the behavior of the sync.
         * @summary Confluence Sync
         * @param {IntegrationsApiSyncConfluenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        syncConfluence(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const syncFilesRequest = {
                    tags: requestParameters.tags,
                    data_source_id: requestParameters.data_source_id,
                    ids: requestParameters.ids,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    max_items_per_chunk: requestParameters.max_items_per_chunk,
                    set_page_as_boundary: requestParameters.set_page_as_boundary,
                    request_id: requestParameters.request_id,
                    use_ocr: requestParameters.use_ocr,
                    parse_pdf_tables_with_ocr: requestParameters.parse_pdf_tables_with_ocr,
                    incremental_sync: requestParameters.incremental_sync,
                    file_sync_config: requestParameters.file_sync_config
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncConfluence(syncFilesRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Sync Data Source Items
         * @param {IntegrationsApiSyncDataSourceItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDataSourceItems(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const syncDirectoryRequest = {
                    data_source_id: requestParameters.data_source_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncDataSourceItems(syncDirectoryRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * After listing files and folders via /integrations/items/sync and integrations/items/list, use the selected items\' external ids  as the ids in this endpoint to sync them into Carbon. Sharepoint items take an additional parameter root_id, which identifies the drive the file or folder is in and is stored in root_external_id. That additional paramter is optional and excluding it will tell the sync to assume the item is stored in the default Documents drive.
         * @summary Sync Files
         * @param {IntegrationsApiSyncFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFiles(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const syncFilesRequest = {
                    tags: requestParameters.tags,
                    data_source_id: requestParameters.data_source_id,
                    ids: requestParameters.ids,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    max_items_per_chunk: requestParameters.max_items_per_chunk,
                    set_page_as_boundary: requestParameters.set_page_as_boundary,
                    request_id: requestParameters.request_id,
                    use_ocr: requestParameters.use_ocr,
                    parse_pdf_tables_with_ocr: requestParameters.parse_pdf_tables_with_ocr,
                    incremental_sync: requestParameters.incremental_sync,
                    file_sync_config: requestParameters.file_sync_config
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncFiles(syncFilesRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Refer this article to obtain an access token https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/managing-your-personal-access-tokens. Make sure that your access token has the permission to read content from your desired repos. Note that if your access token expires you will need to manually update it through this endpoint.
         * @summary Github Connect
         * @param {IntegrationsApiSyncGitHubRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitHub(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const githubConnectRequest = {
                    username: requestParameters.username,
                    access_token: requestParameters.access_token,
                    sync_source_items: requestParameters.sync_source_items,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncGitHub(githubConnectRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * You can sync upto 20 Gitbook spaces at a time using this endpoint. Additional parameters below can be used to associate  data with the synced pages or modify the sync behavior.
         * @summary Gitbook Sync
         * @param {IntegrationsApiSyncGitbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitbook(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const gitbookSyncRequest = {
                    tags: requestParameters.tags,
                    space_ids: requestParameters.space_ids,
                    data_source_id: requestParameters.data_source_id,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    request_id: requestParameters.request_id,
                    file_sync_config: requestParameters.file_sync_config
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncGitbook(gitbookSyncRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Once you have successfully connected your gmail account, you can choose which emails to sync with us using the filters parameter. Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>label</b>: Inbuilt Gmail labels, for example \"Important\" or a custom label you created.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.   <b>is</b>: Can have the following values - starred, important, snoozed, and unread   <b>from</b>: Email address of the sender   <b>to</b>: Email address of the recipient   <b>in</b>: Can have the following values - sent (sync emails sent by the user)   <b>has</b>: Can have the following values - attachment (sync emails that have attachments)    Using keys or values outside of the specified values can lead to unexpected behaviour.  An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"label\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the label \"Test\".  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"label\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"is\",                         \"value\": \"starred\"                     }                 ]             }         ]     } } ``` This will return emails after 7th of Jan that are either starred or have the label \"Personal\".  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
         * @summary Gmail Sync
         * @param {IntegrationsApiSyncGmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGmail(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const gmailSyncInput = {
                    tags: requestParameters.tags,
                    filters: requestParameters.filters,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    data_source_id: requestParameters.data_source_id,
                    request_id: requestParameters.request_id,
                    sync_attachments: requestParameters.sync_attachments,
                    file_sync_config: requestParameters.file_sync_config,
                    incremental_sync: requestParameters.incremental_sync
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncGmail(gmailSyncInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Once you have successfully connected your Outlook account, you can choose which emails to sync with us using the filters and folder parameter. \"folder\" should be the folder you want to sync from Outlook. By default we get messages from your inbox folder.   Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>category</b>: Custom categories that you created in Outlook.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.     <b>is</b>: Can have the following values: flagged   <b>from</b>: Email address of the sender     An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the category \"Test\".    Specifying a custom folder in the same query ```json {     \"folder\": \"Folder Name\",     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ```  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"category\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"category\",                         \"value\": \"Test\"                     },                 ]             }         ]     } } ``` This will return emails after 7th of Jan that have either Personal or Test as category.  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
         * @summary Outlook Sync
         * @param {IntegrationsApiSyncOutlookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOutlook(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const outlookSyncInput = {
                    tags: requestParameters.tags,
                    folder: requestParameters.folder,
                    filters: requestParameters.filters,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    data_source_id: requestParameters.data_source_id,
                    request_id: requestParameters.request_id,
                    sync_attachments: requestParameters.sync_attachments,
                    file_sync_config: requestParameters.file_sync_config,
                    incremental_sync: requestParameters.incremental_sync
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncOutlook(outlookSyncInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * You can retreive repos your token has access to using /integrations/github/repos and sync their content.  You can also pass full name of any public repository (username/repo-name). This will store the repo content with  carbon which can be accessed through /integrations/items/list endpoint. Maximum of 25 repositories are accepted per request.
         * @summary Github Sync Repos
         * @param {IntegrationsApiSyncReposRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRepos(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const githubFetchReposRequest = {
                    repos: requestParameters.repos,
                    data_source_id: requestParameters.data_source_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncRepos(githubFetchReposRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Rss Feed
         * @param {IntegrationsApiSyncRssFeedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRssFeed(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const rSSFeedInput = {
                    tags: requestParameters.tags,
                    url: requestParameters.url,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    request_id: requestParameters.request_id,
                    data_source_tags: requestParameters.data_source_tags
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncRssFeed(rSSFeedInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the bucket name  and object key as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
         * @summary S3 Files
         * @param {IntegrationsApiSyncS3FilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncS3Files(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const s3FileSyncInput = {
                    tags: requestParameters.tags,
                    ids: requestParameters.ids,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    max_items_per_chunk: requestParameters.max_items_per_chunk,
                    set_page_as_boundary: requestParameters.set_page_as_boundary,
                    data_source_id: requestParameters.data_source_id,
                    request_id: requestParameters.request_id,
                    use_ocr: requestParameters.use_ocr,
                    parse_pdf_tables_with_ocr: requestParameters.parse_pdf_tables_with_ocr,
                    file_sync_config: requestParameters.file_sync_config
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncS3Files(s3FileSyncInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * You can list all conversations using the endpoint /integrations/slack/conversations. The ID of  conversation will be used as an input for this endpoint with timestamps as optional filters.
         * @summary Slack Sync
         * @param {IntegrationsApiSyncSlackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSlack(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const slackSyncRequest = {
                    tags: requestParameters.tags,
                    filters: requestParameters.filters,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    data_source_id: requestParameters.data_source_id,
                    request_id: requestParameters.request_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncSlack(slackSyncRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.IntegrationsApiFp = IntegrationsApiFp;
/**
 * IntegrationsApi - factory interface
 * @export
 */
const IntegrationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.IntegrationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Cancel Data Source Items Sync
         * @param {IntegrationsApiCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(requestParameters, options) {
            return localVarFp.cancel(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Connect Data Source
         * @param {IntegrationsApiConnectDataSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectDataSource(requestParameters, options) {
            return localVarFp.connectDataSource(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Refer this article to obtain an API key https://support.freshdesk.com/en/support/solutions/articles/215517. Make sure that your API key has the permission to read solutions from your account and you are on a <b>paid</b> plan. Once you have an API key, you can make a request to this endpoint along with your freshdesk domain. This will  trigger an automatic sync of the articles in your \"solutions\" tab. Additional parameters below can be used to associate  data with the synced articles or modify the sync behavior.
         * @summary Freshdesk Connect
         * @param {IntegrationsApiConnectFreshdeskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectFreshdesk(requestParameters, options) {
            return localVarFp.connectFreshdesk(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * You will need an access token to connect your Gitbook account. Note that the permissions will be defined by the user  generating access token so make sure you have the permission to access spaces you will be syncing.  Refer this article for more details https://developer.gitbook.com/gitbook-api/authentication. Additionally, you need to specify the name of organization you will be syncing data from.
         * @summary Gitbook Connect
         * @param {IntegrationsApiConnectGitbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGitbook(requestParameters, options) {
            return localVarFp.connectGitbook(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * You will need an access token to connect your Guru account. To obtain an access token, follow the steps highlighted here https://help.getguru.com/docs/gurus-api#obtaining-a-user-token. The username should be your Guru username.
         * @summary Guru Connect
         * @param {IntegrationsApiConnectGuruRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGuru(requestParameters, options) {
            return localVarFp.connectGuru(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint can be used to connect S3 as well as Digital Ocean Spaces (S3 compatible)   For S3, create a new IAM user with permissions to: <ol> <li>List all buckets.</li> <li>Read from the specific buckets and objects to sync with Carbon. Ensure any future buckets or objects carry  the same permissions.</li> </ol> Once created, generate an access key for this user and share the credentials with us. We recommend testing this key beforehand.   For Digital Ocean Spaces, generate the above credentials in your Applications and API page here https://cloud.digitalocean.com/account/api/spaces. Endpoint URL is required to connect Digital Ocean Spaces. It should look like <<region>>.digitaloceanspaces.com
         * @summary S3 Auth
         * @param {IntegrationsApiCreateAwsIamUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAwsIamUser(requestParameters, options) {
            return localVarFp.createAwsIamUser(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint can be used to generate the following URLs - An OAuth URL for OAuth based connectors - A file syncing URL which skips the OAuth flow if the user already has a valid access token and takes them to the success state.
         * @summary Get Oauth Url
         * @param {IntegrationsApiGetOauthUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthUrl(requestParameters, options) {
            return localVarFp.getOauthUrl(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint has been deprecated. Use /integrations/items/list instead.  To begin listing a user\'s Confluence pages, at least a `data_source_id` of a connected Confluence account must be specified. This base request returns a list of root pages for every space the user has access to in a Confluence instance. To traverse further down the user\'s page directory, additional requests to this endpoint can be made with the same `data_source_id` and with `parent_id` set to the id of page from a previous request. For convenience, the `has_children` property in each directory item in the response list will flag which pages will return non-empty lists of pages when set as the `parent_id`.
         * @summary Confluence List
         * @param {IntegrationsApiListConfluencePagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listConfluencePages(requestParameters, options) {
            return localVarFp.listConfluencePages(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * List all of your public and private channels, DMs, and Group DMs. The ID from response  can be used as a filter to sync messages to Carbon    types: Comma separated list of types. Available types are im (DMs), mpim (group DMs), public_channel, and private_channel. Defaults to public_channel.     cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request     data_source_id: Data source needs to be specified if you have linked multiple slack accounts   exclude_archived: Should archived conversations be excluded, defaults to true
         * @summary Slack List Conversations
         * @param {IntegrationsApiListConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversations(requestParameters = {}, options) {
            return localVarFp.listConversations(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Data Source Items
         * @param {IntegrationsApiListDataSourceItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDataSourceItems(requestParameters, options) {
            return localVarFp.listDataSourceItems(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * After connecting your Outlook account, you can use this endpoint to list all of your folders on outlook. This includes  both system folders like \"inbox\" and user created folders.
         * @summary Outlook Folders
         * @param {IntegrationsApiListFoldersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolders(requestParameters = {}, options) {
            return localVarFp.listFolders(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * After connecting your Gitbook account, you can use this endpoint to list all of your spaces under current organization.
         * @summary Gitbook Spaces
         * @param {IntegrationsApiListGitbookSpacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGitbookSpaces(requestParameters, options) {
            return localVarFp.listGitbookSpaces(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * After connecting your Gmail account, you can use this endpoint to list all of your labels. User created labels will have the type \"user\" and Gmail\'s default labels will have the type \"system\"
         * @summary Gmail Labels
         * @param {IntegrationsApiListLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels(requestParameters = {}, options) {
            return localVarFp.listLabels(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * After connecting your Outlook account, you can use this endpoint to list all of your categories on outlook. We currently support listing up to 250 categories.
         * @summary Outlook Categories
         * @param {IntegrationsApiListOutlookCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOutlookCategories(requestParameters = {}, options) {
            return localVarFp.listOutlookCategories(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Once you have connected your GitHub account, you can use this endpoint to list the      repositories your account has access to. You can use a data source ID or username to fetch from a specific account.
         * @summary Github List Repos
         * @param {IntegrationsApiListReposRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRepos(requestParameters = {}, options) {
            return localVarFp.listRepos(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * List all Sharepoint sites in the connected tenant. The site names from the response can be used as the site name when connecting a Sharepoint site. If site name is null in the response, then site name should be left null when connecting to the site.  This endpoint requires an additional Sharepoint scope: \"Sites.Read.All\". Include this scope along with the default Sharepoint scopes to list Sharepoint sites, connect to a site, and finally sync files from the site. The default Sharepoint scopes are: [o, p, e, n, i, d,  , o, f, f, l, i, n, e, _, a, c, c, e, s, s,  , U, s, e, r, ., R, e, a, d,  , F, i, l, e, s, ., R, e, a, d, ., A, l, l].   data_soure_id: Data source needs to be specified if you have linked multiple Sharepoint accounts cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request
         * @summary List Sharepoint Sites
         * @param {IntegrationsApiListSharepointSitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharepointSites(requestParameters = {}, options) {
            return localVarFp.listSharepointSites(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the container name  and file name as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
         * @summary Azure Blob Files
         * @param {IntegrationsApiSyncAzureBlobFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAzureBlobFiles(requestParameters, options) {
            return localVarFp.syncAzureBlobFiles(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint can be used to connect Azure Blob Storage.  For Azure Blob Storage, follow these steps: <ol>   <li>Create a new Azure Storage account and grant the following permissions:     <ul>       <li>List containers.</li>       <li>Read from specific containers and blobs to sync with Carbon. Ensure any future containers or blobs carry the same permissions.</li>     </ul>   </li>   <li>Generate a shared access signature (SAS) token or an access key for the storage account.</li> </ol>  Once created, provide us with the following details to generate the connection URL: <ol>   <li>Storage Account KeyName.</li>   <li>Storage Account Name.</li> </ol>
         * @summary Azure Blob Storage Auth
         * @param {IntegrationsApiSyncAzureBlobStorageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAzureBlobStorage(requestParameters, options) {
            return localVarFp.syncAzureBlobStorage(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint has been deprecated. Use /integrations/files/sync instead.  After listing pages in a user\'s Confluence account, the set of selected page `ids` and the connected account\'s `data_source_id` can be passed into this endpoint to sync them into Carbon. Additional parameters listed below can be used to associate data to the selected pages or alter the behavior of the sync.
         * @summary Confluence Sync
         * @param {IntegrationsApiSyncConfluenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        syncConfluence(requestParameters, options) {
            return localVarFp.syncConfluence(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync Data Source Items
         * @param {IntegrationsApiSyncDataSourceItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDataSourceItems(requestParameters, options) {
            return localVarFp.syncDataSourceItems(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * After listing files and folders via /integrations/items/sync and integrations/items/list, use the selected items\' external ids  as the ids in this endpoint to sync them into Carbon. Sharepoint items take an additional parameter root_id, which identifies the drive the file or folder is in and is stored in root_external_id. That additional paramter is optional and excluding it will tell the sync to assume the item is stored in the default Documents drive.
         * @summary Sync Files
         * @param {IntegrationsApiSyncFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFiles(requestParameters, options) {
            return localVarFp.syncFiles(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Refer this article to obtain an access token https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/managing-your-personal-access-tokens. Make sure that your access token has the permission to read content from your desired repos. Note that if your access token expires you will need to manually update it through this endpoint.
         * @summary Github Connect
         * @param {IntegrationsApiSyncGitHubRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitHub(requestParameters, options) {
            return localVarFp.syncGitHub(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * You can sync upto 20 Gitbook spaces at a time using this endpoint. Additional parameters below can be used to associate  data with the synced pages or modify the sync behavior.
         * @summary Gitbook Sync
         * @param {IntegrationsApiSyncGitbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitbook(requestParameters, options) {
            return localVarFp.syncGitbook(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Once you have successfully connected your gmail account, you can choose which emails to sync with us using the filters parameter. Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>label</b>: Inbuilt Gmail labels, for example \"Important\" or a custom label you created.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.   <b>is</b>: Can have the following values - starred, important, snoozed, and unread   <b>from</b>: Email address of the sender   <b>to</b>: Email address of the recipient   <b>in</b>: Can have the following values - sent (sync emails sent by the user)   <b>has</b>: Can have the following values - attachment (sync emails that have attachments)    Using keys or values outside of the specified values can lead to unexpected behaviour.  An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"label\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the label \"Test\".  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"label\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"is\",                         \"value\": \"starred\"                     }                 ]             }         ]     } } ``` This will return emails after 7th of Jan that are either starred or have the label \"Personal\".  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
         * @summary Gmail Sync
         * @param {IntegrationsApiSyncGmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGmail(requestParameters, options) {
            return localVarFp.syncGmail(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Once you have successfully connected your Outlook account, you can choose which emails to sync with us using the filters and folder parameter. \"folder\" should be the folder you want to sync from Outlook. By default we get messages from your inbox folder.   Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>category</b>: Custom categories that you created in Outlook.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.     <b>is</b>: Can have the following values: flagged   <b>from</b>: Email address of the sender     An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the category \"Test\".    Specifying a custom folder in the same query ```json {     \"folder\": \"Folder Name\",     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ```  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"category\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"category\",                         \"value\": \"Test\"                     },                 ]             }         ]     } } ``` This will return emails after 7th of Jan that have either Personal or Test as category.  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
         * @summary Outlook Sync
         * @param {IntegrationsApiSyncOutlookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOutlook(requestParameters, options) {
            return localVarFp.syncOutlook(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * You can retreive repos your token has access to using /integrations/github/repos and sync their content.  You can also pass full name of any public repository (username/repo-name). This will store the repo content with  carbon which can be accessed through /integrations/items/list endpoint. Maximum of 25 repositories are accepted per request.
         * @summary Github Sync Repos
         * @param {IntegrationsApiSyncReposRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRepos(requestParameters, options) {
            return localVarFp.syncRepos(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Rss Feed
         * @param {IntegrationsApiSyncRssFeedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRssFeed(requestParameters, options) {
            return localVarFp.syncRssFeed(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the bucket name  and object key as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
         * @summary S3 Files
         * @param {IntegrationsApiSyncS3FilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncS3Files(requestParameters, options) {
            return localVarFp.syncS3Files(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * You can list all conversations using the endpoint /integrations/slack/conversations. The ID of  conversation will be used as an input for this endpoint with timestamps as optional filters.
         * @summary Slack Sync
         * @param {IntegrationsApiSyncSlackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSlack(requestParameters, options) {
            return localVarFp.syncSlack(requestParameters, options).then((request) => request(axios, basePath));
        },
    };
};
exports.IntegrationsApiFactory = IntegrationsApiFactory;
/**
 * IntegrationsApiGenerated - object-oriented interface
 * @export
 * @class IntegrationsApiGenerated
 * @extends {BaseAPI}
 */
class IntegrationsApiGenerated extends base_1.BaseAPI {
    /**
     *
     * @summary Cancel Data Source Items Sync
     * @param {IntegrationsApiCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    cancel(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).cancel(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Connect Data Source
     * @param {IntegrationsApiConnectDataSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    connectDataSource(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).connectDataSource(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Refer this article to obtain an API key https://support.freshdesk.com/en/support/solutions/articles/215517. Make sure that your API key has the permission to read solutions from your account and you are on a <b>paid</b> plan. Once you have an API key, you can make a request to this endpoint along with your freshdesk domain. This will  trigger an automatic sync of the articles in your \"solutions\" tab. Additional parameters below can be used to associate  data with the synced articles or modify the sync behavior.
     * @summary Freshdesk Connect
     * @param {IntegrationsApiConnectFreshdeskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    connectFreshdesk(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).connectFreshdesk(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * You will need an access token to connect your Gitbook account. Note that the permissions will be defined by the user  generating access token so make sure you have the permission to access spaces you will be syncing.  Refer this article for more details https://developer.gitbook.com/gitbook-api/authentication. Additionally, you need to specify the name of organization you will be syncing data from.
     * @summary Gitbook Connect
     * @param {IntegrationsApiConnectGitbookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    connectGitbook(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).connectGitbook(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * You will need an access token to connect your Guru account. To obtain an access token, follow the steps highlighted here https://help.getguru.com/docs/gurus-api#obtaining-a-user-token. The username should be your Guru username.
     * @summary Guru Connect
     * @param {IntegrationsApiConnectGuruRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    connectGuru(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).connectGuru(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint can be used to connect S3 as well as Digital Ocean Spaces (S3 compatible)   For S3, create a new IAM user with permissions to: <ol> <li>List all buckets.</li> <li>Read from the specific buckets and objects to sync with Carbon. Ensure any future buckets or objects carry  the same permissions.</li> </ol> Once created, generate an access key for this user and share the credentials with us. We recommend testing this key beforehand.   For Digital Ocean Spaces, generate the above credentials in your Applications and API page here https://cloud.digitalocean.com/account/api/spaces. Endpoint URL is required to connect Digital Ocean Spaces. It should look like <<region>>.digitaloceanspaces.com
     * @summary S3 Auth
     * @param {IntegrationsApiCreateAwsIamUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    createAwsIamUser(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).createAwsIamUser(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint can be used to generate the following URLs - An OAuth URL for OAuth based connectors - A file syncing URL which skips the OAuth flow if the user already has a valid access token and takes them to the success state.
     * @summary Get Oauth Url
     * @param {IntegrationsApiGetOauthUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    getOauthUrl(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).getOauthUrl(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint has been deprecated. Use /integrations/items/list instead.  To begin listing a user\'s Confluence pages, at least a `data_source_id` of a connected Confluence account must be specified. This base request returns a list of root pages for every space the user has access to in a Confluence instance. To traverse further down the user\'s page directory, additional requests to this endpoint can be made with the same `data_source_id` and with `parent_id` set to the id of page from a previous request. For convenience, the `has_children` property in each directory item in the response list will flag which pages will return non-empty lists of pages when set as the `parent_id`.
     * @summary Confluence List
     * @param {IntegrationsApiListConfluencePagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listConfluencePages(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listConfluencePages(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List all of your public and private channels, DMs, and Group DMs. The ID from response  can be used as a filter to sync messages to Carbon    types: Comma separated list of types. Available types are im (DMs), mpim (group DMs), public_channel, and private_channel. Defaults to public_channel.     cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request     data_source_id: Data source needs to be specified if you have linked multiple slack accounts   exclude_archived: Should archived conversations be excluded, defaults to true
     * @summary Slack List Conversations
     * @param {IntegrationsApiListConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listConversations(requestParameters = {}, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listConversations(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List Data Source Items
     * @param {IntegrationsApiListDataSourceItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listDataSourceItems(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listDataSourceItems(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * After connecting your Outlook account, you can use this endpoint to list all of your folders on outlook. This includes  both system folders like \"inbox\" and user created folders.
     * @summary Outlook Folders
     * @param {IntegrationsApiListFoldersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listFolders(requestParameters = {}, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listFolders(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * After connecting your Gitbook account, you can use this endpoint to list all of your spaces under current organization.
     * @summary Gitbook Spaces
     * @param {IntegrationsApiListGitbookSpacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listGitbookSpaces(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listGitbookSpaces(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * After connecting your Gmail account, you can use this endpoint to list all of your labels. User created labels will have the type \"user\" and Gmail\'s default labels will have the type \"system\"
     * @summary Gmail Labels
     * @param {IntegrationsApiListLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listLabels(requestParameters = {}, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listLabels(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * After connecting your Outlook account, you can use this endpoint to list all of your categories on outlook. We currently support listing up to 250 categories.
     * @summary Outlook Categories
     * @param {IntegrationsApiListOutlookCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listOutlookCategories(requestParameters = {}, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listOutlookCategories(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Once you have connected your GitHub account, you can use this endpoint to list the      repositories your account has access to. You can use a data source ID or username to fetch from a specific account.
     * @summary Github List Repos
     * @param {IntegrationsApiListReposRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listRepos(requestParameters = {}, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listRepos(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List all Sharepoint sites in the connected tenant. The site names from the response can be used as the site name when connecting a Sharepoint site. If site name is null in the response, then site name should be left null when connecting to the site.  This endpoint requires an additional Sharepoint scope: \"Sites.Read.All\". Include this scope along with the default Sharepoint scopes to list Sharepoint sites, connect to a site, and finally sync files from the site. The default Sharepoint scopes are: [o, p, e, n, i, d,  , o, f, f, l, i, n, e, _, a, c, c, e, s, s,  , U, s, e, r, ., R, e, a, d,  , F, i, l, e, s, ., R, e, a, d, ., A, l, l].   data_soure_id: Data source needs to be specified if you have linked multiple Sharepoint accounts cursor: Used for pagination. If next_cursor is returned in response, you need to pass it as the cursor in the next request
     * @summary List Sharepoint Sites
     * @param {IntegrationsApiListSharepointSitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    listSharepointSites(requestParameters = {}, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).listSharepointSites(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the container name  and file name as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
     * @summary Azure Blob Files
     * @param {IntegrationsApiSyncAzureBlobFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncAzureBlobFiles(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncAzureBlobFiles(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint can be used to connect Azure Blob Storage.  For Azure Blob Storage, follow these steps: <ol>   <li>Create a new Azure Storage account and grant the following permissions:     <ul>       <li>List containers.</li>       <li>Read from specific containers and blobs to sync with Carbon. Ensure any future containers or blobs carry the same permissions.</li>     </ul>   </li>   <li>Generate a shared access signature (SAS) token or an access key for the storage account.</li> </ol>  Once created, provide us with the following details to generate the connection URL: <ol>   <li>Storage Account KeyName.</li>   <li>Storage Account Name.</li> </ol>
     * @summary Azure Blob Storage Auth
     * @param {IntegrationsApiSyncAzureBlobStorageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncAzureBlobStorage(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncAzureBlobStorage(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint has been deprecated. Use /integrations/files/sync instead.  After listing pages in a user\'s Confluence account, the set of selected page `ids` and the connected account\'s `data_source_id` can be passed into this endpoint to sync them into Carbon. Additional parameters listed below can be used to associate data to the selected pages or alter the behavior of the sync.
     * @summary Confluence Sync
     * @param {IntegrationsApiSyncConfluenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncConfluence(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncConfluence(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync Data Source Items
     * @param {IntegrationsApiSyncDataSourceItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncDataSourceItems(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncDataSourceItems(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * After listing files and folders via /integrations/items/sync and integrations/items/list, use the selected items\' external ids  as the ids in this endpoint to sync them into Carbon. Sharepoint items take an additional parameter root_id, which identifies the drive the file or folder is in and is stored in root_external_id. That additional paramter is optional and excluding it will tell the sync to assume the item is stored in the default Documents drive.
     * @summary Sync Files
     * @param {IntegrationsApiSyncFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncFiles(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncFiles(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Refer this article to obtain an access token https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/managing-your-personal-access-tokens. Make sure that your access token has the permission to read content from your desired repos. Note that if your access token expires you will need to manually update it through this endpoint.
     * @summary Github Connect
     * @param {IntegrationsApiSyncGitHubRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncGitHub(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncGitHub(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * You can sync upto 20 Gitbook spaces at a time using this endpoint. Additional parameters below can be used to associate  data with the synced pages or modify the sync behavior.
     * @summary Gitbook Sync
     * @param {IntegrationsApiSyncGitbookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncGitbook(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncGitbook(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Once you have successfully connected your gmail account, you can choose which emails to sync with us using the filters parameter. Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>label</b>: Inbuilt Gmail labels, for example \"Important\" or a custom label you created.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.   <b>is</b>: Can have the following values - starred, important, snoozed, and unread   <b>from</b>: Email address of the sender   <b>to</b>: Email address of the recipient   <b>in</b>: Can have the following values - sent (sync emails sent by the user)   <b>has</b>: Can have the following values - attachment (sync emails that have attachments)    Using keys or values outside of the specified values can lead to unexpected behaviour.  An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"label\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the label \"Test\".  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"label\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"is\",                         \"value\": \"starred\"                     }                 ]             }         ]     } } ``` This will return emails after 7th of Jan that are either starred or have the label \"Personal\".  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
     * @summary Gmail Sync
     * @param {IntegrationsApiSyncGmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncGmail(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncGmail(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Once you have successfully connected your Outlook account, you can choose which emails to sync with us using the filters and folder parameter. \"folder\" should be the folder you want to sync from Outlook. By default we get messages from your inbox folder.   Filters is a JSON object with key value pairs. It also supports AND and OR operations. For now, we support a limited set of keys listed below.  <b>category</b>: Custom categories that you created in Outlook.   <b>after</b> or <b>before</b>: A date in YYYY/mm/dd format (example 2023/12/31). Gets emails after/before a certain date. You can also use them in combination to get emails from a certain period.     <b>is</b>: Can have the following values: flagged   <b>from</b>: Email address of the sender     An example of a basic query with filters can be ```json {     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ``` Which will list all emails that have the category \"Test\".    Specifying a custom folder in the same query ```json {     \"folder\": \"Folder Name\",     \"filters\": {             \"key\": \"category\",             \"value\": \"Test\"         } } ```  You can use AND and OR operation in the following way: ```json {     \"filters\": {         \"AND\": [             {                 \"key\": \"after\",                 \"value\": \"2024/01/07\"             },             {                 \"OR\": [                     {                         \"key\": \"category\",                         \"value\": \"Personal\"                     },                     {                         \"key\": \"category\",                         \"value\": \"Test\"                     },                 ]             }         ]     } } ``` This will return emails after 7th of Jan that have either Personal or Test as category.  Note that this is the highest level of nesting we support, i.e. you can\'t add more AND/OR filters within the OR filter in the above example.
     * @summary Outlook Sync
     * @param {IntegrationsApiSyncOutlookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncOutlook(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncOutlook(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * You can retreive repos your token has access to using /integrations/github/repos and sync their content.  You can also pass full name of any public repository (username/repo-name). This will store the repo content with  carbon which can be accessed through /integrations/items/list endpoint. Maximum of 25 repositories are accepted per request.
     * @summary Github Sync Repos
     * @param {IntegrationsApiSyncReposRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncRepos(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncRepos(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Rss Feed
     * @param {IntegrationsApiSyncRssFeedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncRssFeed(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncRssFeed(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * After optionally loading the items via /integrations/items/sync and integrations/items/list, use the bucket name  and object key as the ID in this endpoint to sync them into Carbon. Additional parameters below can associate  data with the selected items or modify the sync behavior
     * @summary S3 Files
     * @param {IntegrationsApiSyncS3FilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncS3Files(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncS3Files(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * You can list all conversations using the endpoint /integrations/slack/conversations. The ID of  conversation will be used as an input for this endpoint with timestamps as optional filters.
     * @summary Slack Sync
     * @param {IntegrationsApiSyncSlackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiGenerated
     */
    syncSlack(requestParameters, options) {
        return (0, exports.IntegrationsApiFp)(this.configuration).syncSlack(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.IntegrationsApiGenerated = IntegrationsApiGenerated;
